import * as types from "./actionTypes";

export const setGroheWizardOpened = (wizardOpened = false) => ({
  type: types.SET_GROHE_WIZARD_OPENED,
  payload: {wizardOpened}
});

export const setGroheWizardName = (wizardName = false) => ({
  type: types.SET_GROHE_WIZARD_NAME,
  payload: {wizardName}
});

export const setGroheWizardStep = (wizardStep = false) => ({
  type: types.SET_GROHE_WIZARD_STEP,
  payload: {wizardStep}
});
